export const NOTION_ID = /^[\da-f]{8}-?[\da-f]{4}-?[\da-f]{4}-?[\da-f]{4}-?[\da-f]{12}$/i

export const NOTION_ID_MAX_LENGTH = 36

export const canonicalNotionId = (id: string) => {
  const hex = id.replaceAll('-', '').toLowerCase()
  return [
    hex.slice(0, 8),
    hex.slice(8, 12),
    hex.slice(12, 16),
    hex.slice(16, 20),
    hex.slice(20),
  ].join('-')
}
